import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { Filter } from '../../components/_WMS/FilterComponent'
import { utcFinalDate, utcIntialDate } from '../../utils/dateHelper'
import { eTypeWorkOrder } from '../../enums/eTypeWorkOrder'
import { WorkOrderRecall } from './entities/WorkOrderRecall'
import { templateCreateMassiveOrderRecall } from '../../const/templatesFileName'

export const getOrderRecallList = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(
    `${ApiConfig.WorkOrderRecallApi}?TypeWorkOrderId=${eTypeWorkOrder.Recall}`
  )
  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialPromiseDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalPromiseDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const updateWorkOrderRecall = (id: number, dto: WorkOrderRecall) => {
  const url = new URL(`${ApiConfig.WorkOrderRecallApi}/${id}`)
  return axios.put(url.toString(), dto)
}

export const getWorkOrderRecallTemplate = () => {
  const url = new URL(
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateCreateMassiveOrderRecall}`
  )
  return axios.get(url.toString())
}

export const postWorkOrderRecall = (dto: FormData) => {
  const url = new URL(`${ApiConfig.ProcessApi}/WorkOrderRecallUploadFile`)

  const headers = {
    'Content-Type': 'multipart/form-data'
  }

  return axios.post(url.toString(), dto, { headers })
}

export const getWorkOrderSkus = (workOrderId: number) => {
  const url = new URL(`${ApiConfig.WorkOrderApi}/${workOrderId}/skus`)

  // url.searchParams.set('workOrderId', workOrderId.toString())

  return axios.get(url.toString())
}
